/** Способ создания черновика: подача декларации с целью получения вычета по расходам на образование */
export const DRAFT_MODE = 4;
export const STEP_DEDUCTION = 'deductions';
export const STEP_DEDUCTION_FORM = `${STEP_DEDUCTION}Form`;
